/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ausgewählte Daten löschen`
};

const en_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Delete selected dates`
};

const es_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Borrar fechas seleccionadas`
};

const fr_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Effacer les dates sélectionnées`
};

const it_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Cancellare le date selezionate`
};

const nl_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Geselecteerde data verwijderen`
};

const pt_date_range_picker__close_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar datas selecionadas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__close_aria_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date_range_picker__close_aria_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date_range_picker__close_aria_label", locale)
	if (locale === "de") return de_date_range_picker__close_aria_label(inputs)
	if (locale === "en") return en_date_range_picker__close_aria_label(inputs)
	if (locale === "es") return es_date_range_picker__close_aria_label(inputs)
	if (locale === "fr") return fr_date_range_picker__close_aria_label(inputs)
	if (locale === "it") return it_date_range_picker__close_aria_label(inputs)
	if (locale === "nl") return nl_date_range_picker__close_aria_label(inputs)
	return pt_date_range_picker__close_aria_label(inputs)
};